export default "__VITE_ASSET__DREaU5uv__"